import {
    createBrowserRouter
} from "react-router-dom";

// PAGES  

import Login from '../components/authentication/login'
import ForgotPassword from '../components/authentication/forgotPassword'
import CheckEmail from '../components/authentication/checkEmail';
import CodeVerification from '../components/authentication/codeVerification';
import ResetPassword from '../components/authentication/resetPassword';
import Error404Page from '../components/error/Error404Page'
import Dashboard from "../components/portal/dashboard/dashboard";
import RevenueReports from "../components/portal/key_metrics/revenue_reports";
import OccupancyReports from "../components/portal/key_metrics/occupancy_reports";
import ExpenseReports from "../components/portal/key_metrics/expense_reports";
import LeaseApprovals from "../components/portal/task_approvals/lease_approvals";
import ExpenseApprovals from "../components/portal/task_approvals/expense_approvals";
import MaintenanceApprovals from "../components/portal/task_approvals/maintenance_approvals";
import ViewApprovalTicket from "../components/portal/task_approvals/view_approval_ticket";
import ViewUnit from "../components/portal/key_metrics/view_unit";
import ViewInvoice from "../components/portal/key_metrics/view_invoice";
import Facilities from "../components/app/facility_management/facilities";
import Wallet from "../components/portal/dashboard/wallet";





export const router = createBrowserRouter([
    {
        path: "/",
        element: <Login />,
    },
    {
        path: "/forgot_password",
        element: <ForgotPassword />,
    },
    {
        path: "/check_email",
        element: <CheckEmail />,
    },
    {
        path: "/code_verification",
        element: <CodeVerification />,
    },
    {
        path: "/reset_password/:userId",
        element: <ResetPassword />,
    },
    {
        path: "/landlord/facilities",
        element: <Facilities />,
    },
    {
        path: "/landlord_portal",
        element: <Dashboard />,
    },
    {
        path: "/wallet",
        element: <Wallet />,
    },
    {
        path: "/portal/metrics/expense_reports",
        element: <ExpenseReports />,
    },
    {
        path: "/portal/metrics/occupancy_reports",
        element: <OccupancyReports />,
    },
    {
        path: "/portal/occupancy_reports/view_unit/:unitId",
        element: <ViewUnit />,
    },
    {
        path: "/portal/metrics/revenue_reports",
        element: <RevenueReports />,
    },
    {
        path: "/portal/approvals/lease_approvals",
        element: <LeaseApprovals />,
    },
    {
        path: "/portal/approvals/expense_appprovals",
        element: <ExpenseApprovals />,
    },
    {
        path: "/portal/approvals/maintenance_appprovals",
        element: <MaintenanceApprovals />,
    },
    {
        path: "/portal/approvals/view_approval_ticket/:ticketId",
        element: <ViewApprovalTicket />,
    },
    {
        path: "/portal/view_invoice/:invoiceId",
        element: <ViewInvoice />,
    },


    {
        path: "*",
        element: <Error404Page />,
    },
]);